import React from "react";

const SuperAdminRegForm = ({
  handleChange,
  handleSubmit,
  values,
  name,
  setName,
  sameEmail,
  email,
  setPassword,
  password,
}) => {
  return (
    <form className="registration-form" onSubmit={handleSubmit}>
      <div className="mb-3">
        <label htmlFor="username" className="form-label">
          Your Name
        </label>
        <input
          type="text"
          name="username"
          value={name}
          className="form-control"
          id="username"
          onChange={(e) => setName(e.target.value)}
          required
        />
      </div>
      <div className="mb-3">
        <label htmlFor="exampleInputEmail1" className="form-label">
          Email address
        </label>
        <input
          type="email"
          className="form-control"
          name="email"
          value={sameEmail ? email : values.email}
          onChange={handleChange}
          id="exampleInputEmail1"
          aria-describedby="emailHelp"
          disabled={sameEmail}
          required
        />
      </div>
      <div className="mb-3">
        <label htmlFor="exampleInputPassword1" className="form-label">
          Password
        </label>
        <input
          type="password"
          className="form-control"
          id="exampleInputPassword1"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          required
        />
      </div>
      <button type="submit" className="btn btn-primary">
        Submit
      </button>
    </form>
  );
};

export default SuperAdminRegForm;
